/* backstop-only: when user selects 3-Month or 6-Month, briefly select 1-Month, then restore */
(() => {
  const LABEL_1 = [
    'label.e-custom-variant[data-val="1-Month"]',
    
  ].join(','); //join is used here to overwrite a dynamic variable on page load DO NOT TOUCH

  const LABEL_TRIGGERS = [
    'label.e-custom-variant[data-val="3-Month"]',
    'label.e-custom-variant[data-val="6-Month"]',
  ].join(','); //join is used here for the same reason as label 1 DO NOT TOUCH

  // Small delay lets plugins process 1-Month before restoring (try 120 if needed if 40 isn't enough)
  const RESTORE_DELAY_MS = 40;

  // Lockdown helpers to keep the script focused on the correct elements even after the radio button changes on selection
  function inputForLabel(labelEl) {
    if (!labelEl) return null;
    const forId = labelEl.getAttribute('for');
    if (forId) return document.getElementById(forId);
    return labelEl.querySelector('input');
  }
  function labelForInput(inputEl) {
    if (!inputEl || !inputEl.id) return null;
    return document.querySelector(`label[for="${CSS.escape(inputEl.id)}"]`);
  }
  function activateInput(inputEl) {
    if (!inputEl || inputEl.disabled) return;
    if (inputEl.type === 'radio' && inputEl.name) {
      document
        .querySelectorAll(`input[type="radio"][name="${CSS.escape(inputEl.name)}"]`)
        .forEach(r => { r.checked = (r === inputEl); });
    } else if ('checked' in inputEl) {
      inputEl.checked = true;
    }
    inputEl.dispatchEvent(new Event('input',  { bubbles: true }));
    inputEl.dispatchEvent(new Event('change', { bubbles: true }));
  }

  // Guard to ignore our own synthetic changes
  let internalChange = false;

  // React when any radio changes to checked; if it's 3-Month or 6-Month, do the swap-then-restore.
  document.addEventListener('change', (e) => {
    if (internalChange) return;

    const el = e.target;
    if (!el || el.tagName !== 'INPUT' || el.type !== 'radio' || !el.checked) return;

    const selectedLabel = labelForInput(el);
    if (!selectedLabel) return;

    // Only trigger when user picked 3-Month or 6-Month
    if (!selectedLabel.matches(LABEL_TRIGGERS)) return;

    // Find 1-Month to pre-activate
    const label1 = document.querySelector(LABEL_1);
    const input1 = inputForLabel(label1);
    if (!input1) return;

    const inputOriginal = el; // 3-Month or 6-Month radio that the user chose

    // Step 1: briefly activate 1-Month to trigger plugin logic
    internalChange = true; // Guard removed before change to avoid visual stuttering
    activateInput(input1);

    // Step 2: restore the user's original selection after a short beat
    const restore = () => {
      try {
        activateInput(inputOriginal);
      } finally {
        requestAnimationFrame(() => { internalChange = false; });
      }
    };

    if (RESTORE_DELAY_MS > 0) setTimeout(restore, RESTORE_DELAY_MS);
    else requestAnimationFrame(restore);
  }, true); // capture final animation frame to prevent any conflict between this script and the functionalities of the others
})();
